// Leads.jsx com formulário reorganizado e campo origem removidos
import React, { useEffect, useState, useMemo, useRef } from "react";
import { useTable, useGlobalFilter, useFilters, useSortBy } from "react-table";
import {
  PlusCircle,
  Edit,
  Eye,
  Trash,
  Save,
  MoreHorizontal,
  Zap,
  ClipboardList,
  TrafficLight,
  Trash2,
  CheckCircle,
  CircleDollarSign,
  XCircle,
  RotateCcw,
  AlertCircle,
  CornerDownRight,
  CalendarCheck,
  PhoneCall,
  BookOpen,
  Target,
  HandCoins,
  Search,
} from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Leads.css";

import logoCapta from "../assets/logo-capta.png";
import TarefaModal from "../Components/TarefaModal";
import InteracoesModal from "../Components/InteracoesModal";
import NotificacaoTarefa from "../Components/NotificacaoTarefa";
import { api } from "../api";
import {
  MdOutlineReportProblem,
  MdEdit,
  MdDelete,
  MdVisibility,
} from "react-icons/md";
import { motion } from "framer-motion";
import { FcEditImage, FcFullTrash, FcInspection } from "react-icons/fc";
import DropdownAcoes from "../Components/DropdownAcoes";
import getCorBolinhaStatusLead from "../utils/getCorBolinhaStatusLead";
import ModalLegendaBolinhas from "../Components/ModalLegendaBolinhas";
import RecebimentoModal from "../Components/RecebimentoModal";
import LogsModalLead from "../Components/LogsModalLead";
import IndicadoresLeads from "../Components/dashboard/IndicadoresLeads";
import CaptaChatWidget from "../utils/CaptaChatWidget";
import LeadPrintPage from "../Components/LeadPrintPage";
import RankingCaptadores from "../Components/dashboard/RankingCaptadores";
import CountUp from "react-countup";
import TermometroConversao from "../Components/TermometroConversao";
import AgendamentosModal from "../Components/AgendamentosModal";
import FiltroDataDinamico from "../Components/FiltroDataDinamico";
import LeadsExportExcel from "../Components/LeadsExportExcel";
import LeadsWhatsApp from "../Components/LeadsWhatsApp";
import { FaWhatsapp } from "react-icons/fa";
import WhatsappIconWithBadge from "../Components/WhatsappIconWithBadge";
import styled from "styled-components";
import { useEmpresa } from "../context/EmpresaContext"; // ← ajusta o caminho se necessário
import FormLead from "./FormLead";
import CadeadoLead from "../Components/CadeadoLeads";

// topo do Leads.jsx
import {
  initLeadsTelemetry,
  useRenderCounter,
  appMarkStart,
  appMarkEnd,
} from "../utils/leadsTelemetryPro";
import { getApiBase } from "../utils/apiBase";

// --- FLAG MODO TURBO (após os imports, no topo do Leads.jsx) ---
if (typeof window !== "undefined" && !window.CAPTA_MODE) {
  window.CAPTA_MODE = "turbo-perf-lite";
}
const IS_TURBO =
  typeof window !== "undefined" && window.CAPTA_MODE === "turbo-perf-lite";

// === PERF-LITE helpers (ultra simples) =========================
function getDomWeight() {
  const el = document.getElementById("tabela-leads");
  if (!el) return { rows: 0, cells: 0 };
  const rows =
    el.querySelectorAll("tr").length ||
    el.querySelectorAll("[role='row']").length;
  const cells =
    el.querySelectorAll("td,th").length ||
    el.querySelectorAll("[role='cell']").length;
  return { rows, cells };
}
async function postPerfLite({ empresaId, userId, app_ms }) {
  const url = `${getApiBase()}/telemetria/leads`;
  const clientVersion =
    (typeof window !== "undefined" && window.CAPTA_MODE) || "stable";
  const body = {
    empresa_id: empresaId ?? null,
    user_id: userId ?? null,
    page: "leads",
    client_version: clientVersion, // <- AQUI!
    sent_at: new Date().toISOString(),
    dom: getDomWeight(),
    app_ms,
  };
  try {
    await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      credentials: "include",
      keepalive: true,
    });
  } catch {}
}
// ===============================================================

//-------------Central Hooks-----------------------------------////

const statusNegociacaoOpcoes = [
  {
    label: "Fechado",
    value: "Fechado",
    icon: <CheckCircle className="w-4 h-4 text-green-600" />,
  },
  {
    label: "Fechado Parcial",
    value: "Fechado Parcial",
    icon: <CircleDollarSign className="w-4 h-4 text-emerald-500" />,
  },
  {
    label: "Negociando",
    value: "Negociando",
    icon: <RotateCcw className="w-4 h-4 text-yellow-500" />,
  },
  {
    label: "Pendente",
    value: "Pendente",
    icon: <AlertCircle className="w-4 h-4 text-gray-500" />,
  },
  {
    label: "Prospectando",
    value: "Prospectando",
    icon: <Search className="w-4 h-4 text-sky-500" />,
  },
  {
    label: "Migrou Concorrência",
    value: "Migrou Concorrência",
    icon: <CornerDownRight className="w-4 h-4 text-orange-500" />,
  },
  {
    label: "Perdido",
    value: "Perdido",
    icon: <XCircle className="w-4 h-4 text-red-500" />,
  },
];

// Filtro padrão que será usado nas colunas da tabela
function DefaultColumnFilter({ column: { filterValue, setFilter } }) {
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value)}
      placeholder="Filtrar..."
      className="w-full px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none"
    />
  );
}

function parseLocalDate(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return null;
  const [year, month, day] = dateStr.slice(0, 10).split("-");
  if (!year || !month || !day) return null;
  return Number(year + month + day); // "2025-08-12" -> 20250812
}

function getPrimeiroNomeById(id, usuarios) {
  const user = usuarios.find((u) => String(u.id) === String(id));
  return user ? user.nome.split(" ")[0] : "";
}

export default function Leads() {
  const [tarefas, setTarefas] = useState([]);
  const [mostrarLegenda, setMostrarLegenda] = useState(false);
  const [modalRecebimentoAberto, setModalRecebimentoAberto] = useState(false);
  const [leadSelecionada, setLeadSelecionada] = useState(null);
  const [leadSelecionadaLogs, setLeadSelecionadaLogs] = useState(null);
  const [mostrarLogsModal, setMostrarLogsModal] = useState(false);
  const [interacoes, setInteracoes] = useState([]);
  const [mostrarInativas, setMostrarInativas] = useState(false);
  const [procedimentos, setProcedimentos] = useState([]);
  const [regioes, setRegioes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [dentistas, setDentistas] = useState([]);
  const [fontes, setFontes] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [interacoesModalAberto, setInteracoesModalAberto] = useState(false);
  const [leadSelecionadaParaInteracao, setLeadSelecionadaParaInteracao] =
    useState(null);
  const [interacoesDaLead, setInteracoesDaLead] = useState([]);
  const [campanhas, setCampanhas] = useState([]);
  const [filtroPotencial, setFiltroPotencial] = useState("");
  const [filtroStatus, setFiltroStatus] = useState("");
  const [filtroPeriodo, setFiltroPeriodo] = useState("");
  const [filtroDentista, setFiltroDentista] = useState("");
  const [filtroFonte, setFiltroFonte] = useState("");
  const [filtroCaptador, setFiltroCaptador] = useState("");
  const [filtroRegiao, setFiltroRegiao] = useState("");
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [erroData, setErroData] = useState(false);
  const [filtroCampanha, setFiltroCampanha] = useState("");
  const [filtroNegociacao, setFiltroNegociacao] = useState("");
  const [filtroProcedimento, setFiltroProcedimento] = useState("");
  const [nomeFiltro, setNomeFiltro] = useState("");
  const [telFiltro, setTelFiltro] = useState("");
  const fecharModalInteracao = () => setInteracoesModalAberto(false);
  const fecharModalLogs = () => setMostrarLogsModal(false);
  const [modalAberto, setModalAberto] = useState(false);
  const [filtroStatusNegociacao, setFiltroStatusNegociacao] = useState("");
  const [recebimentos, setRecebimentos] = useState([]);
  const [filtroDataAgendamento, setFiltroDataAgendamento] = useState("");
  const [soMeusLeads, setSoMeusLeads] = useState(false);
  const [filtroTarefasAtrasadas, setFiltroTarefasAtrasadas] = useState(false);
  const [filtroSemTarefa, setFiltroSemTarefa] = useState(false);
  const [soTarefasAtrasadas, setSoTarefasAtrasadas] = useState(false);
  const [filtroPendenciasHoje, setFiltroPendenciasHoje] = useState(false);
  const [recebLeads, setRecebLeads] = useState([]);
  const [modalAgendamentoAberto, setModalAgendamentoAberto] = useState(false);
  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState(null);
  const [tipoDataFiltro, setTipoDataFiltro] = useState("criado_em");
  const [dataLeadInicio, setDataLeadInicio] = useState("");
  const [dataLeadFim, setDataLeadFim] = useState("");
  const [agendamentos, setAgendamentos] = useState([]);
  const [leadChatAberto, setLeadChatAberto] = useState(null);
  const [badgesWhatsapp, setBadgesWhatsapp] = useState({});

  // --- correção: leitura segura do localStorage + empresaId consolidado
  const { empresaAtiva } = useEmpresa();
  const usuarioLogado = useMemo(() => {
    if (typeof window === "undefined") return {};
    try {
      return JSON.parse(localStorage.getItem("usuarioLogado") || "{}");
    } catch {
      return {};
    }
  }, []);
  const [todasLeads, setTodasLeads] = useState([]);
  const [leads, setLeads] = useState([]);
  const empresaId = empresaAtiva?.id ?? usuarioLogado?.empresa_id ?? null;

  // perf-lite: marcador de início/fim (não mexe na sua fetchLeads)
  const perfLiteRef = useRef({ t0: 0 }); // ⬅️ perf-lite
  const tbodyRef = useRef(null);

  // dentro do componente (um único useEffect)
  useEffect(() => {
    if (typeof window === "undefined") return;

    initLeadsTelemetry({
      apiBase: getApiBase(),
      empresaId: empresaAtiva?.id ?? usuarioLogado?.empresa_id ?? null,
      userId: usuarioLogado?.id ?? null,
      tableRootSelector: "#tabela-leads", // <- precisa existir
      sampleRate: IS_TURBO ? 0.3 : 0.2,
      flushIntervalMs: 10000,
      clientVersion: window.CAPTA_MODE, // <- AQUI!
    });
  }, []);

  useRenderCounter("Leads.jsx"); // conta tempo de render (baratinho)

  useEffect(() => {
    if (dataInicio && dataFim) {
      const inicio = new Date(dataInicio);
      const fim = new Date(dataFim);
      if (fim < inicio) {
        setErroData(true);
        toast.error("⚠️ A Data Fim não pode ser menor que a Data Início");
      } else {
        setErroData(false);
      }
    } else {
      setErroData(false);
    }
  }, [dataInicio, dataFim]);

  const defaultColumn = useMemo(
    () => ({
      Filter: DefaultColumnFilter,
    }),
    [],
  );

  useEffect(() => {
    async function fetchAgendamentos() {
      try {
        const empresaId =
          empresaAtiva?.id ||
          JSON.parse(localStorage.getItem("usuarioLogado") || "{}")?.empresa_id;
        if (!empresaId) return;
        const res = await api.get(`/agendamentos/empresa/${empresaId}`);
        setAgendamentos(Array.isArray(res.data) ? res.data : res);
      } catch (err) {
        setAgendamentos([]);
        console.error("Erro ao carregar agendamentos:", err);
      }
    }
    fetchAgendamentos();
  }, [empresaAtiva?.id]);

  // ⬇️ ADICIONE AQUI
  useEffect(() => {
    if (empresaAtiva?.id) {
      fetchDentistas();
    } else {
      setDentistas([]);
    }
  }, [empresaAtiva?.id]);

  useEffect(() => {
    if (!erroData) {
      // marca início da medição antes de chamar sua fetchLeads
      perfLiteRef.current.t0 = performance.now(); // ⬅️ perf-lite
      fetchLeads();
    }
    // eslint-disable-next-line
  }, [
    dataInicio,
    dataFim,
    mostrarInativas,
    filtroDataAgendamento,
    tipoDataFiltro,
  ]);

  // quando `leads` muda, fechamos a medição e enviamos
  useEffect(() => {
    const t0 = perfLiteRef.current.t0;
    if (!t0) return;
    const ms = Math.round(performance.now() - t0);
    perfLiteRef.current.t0 = 0;
    postPerfLite({
      empresaId,
      userId: usuarioLogado?.id ?? null,
      app_ms: ms,
    }); // ⬅️ perf-lite
    // opcional: console.log("[PERF] leads carregadas em", ms, "ms");
  }, [leads]); // ⬅️ perf-lite

  const handleAbrirChatWhatsapp = async (lead) => {
    const empresaId = lead.empresa_id || empresaAtiva?.id;

    if (!empresaId) {
      console.error(
        "❌ ERRO: empresa_id está undefined no handleAbrirChatWhatsapp",
      );
      return;
    }

    // Garante que setLeadChatAberto tenha o campo empresa_id
    setLeadChatAberto({ ...lead, empresa_id: empresaId });

    try {
      await fetch("/api/whatsapp/marcar-lidas", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ lead_id: lead.id, empresa_id: empresaId }), // 🔥 aqui é o ponto-chave
      });

      setBadgesWhatsapp((prev) => ({
        ...prev,
        [lead.id]: { count: 0, status: null },
      }));
    } catch (err) {
      console.error("❌ Erro ao marcar mensagens como lidas:", err);
    }
  };

  //buscar leads filtrados por agendamento

  // Helper: soma dias mantendo formato YYYY-MM-DD (LOCAL, sem UTC)
  const pad2 = (n) => String(n).padStart(2, "0");
  function addDaysLocal(ymd, days) {
    if (!ymd) return ymd;
    const [y, m, d] = ymd.split("-").map(Number);
    const dt = new Date(y, m - 1, d);
    dt.setDate(dt.getDate() + days);
    return `${dt.getFullYear()}-${pad2(dt.getMonth() + 1)}-${pad2(
      dt.getDate(),
    )}`;
  }

  // Buscar leads por agendamento (corrigido: end exclusivo -> +1 dia)
  async function buscarLeadsPorAgendamento(empresaId, dataInicio, dataFim) {
    const token = localStorage.getItem("token");
    if (!empresaId || !dataInicio || !dataFim) return [];

    // 👉 garante que o último dia selecionado seja incluído
    const endExclusivo = addDaysLocal(dataFim, 1);

    const url = `https://api.captacrm.com.br/agendamentos/leads-filtrados/${empresaId}?start=${encodeURIComponent(
      dataInicio,
    )}&end=${encodeURIComponent(endExclusivo)}`;

    const resp = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!resp.ok)
      throw new Error("Erro ao buscar leads filtrados por agendamento");
    return await resp.json();
  }

  // Mapa do último agendamento por lead (considerando maior data e, em empate, maior ID)

  const ultimoAgendamentoPorLead = useMemo(() => {
    const map = new Map(); // lead_id -> agendamento
    for (const a of agendamentos || []) {
      const atual = map.get(a.lead_id);
      if (!atual || Number(a.id) > Number(atual.id)) {
        map.set(a.lead_id, a);
      }
    }
    return map;
  }, [agendamentos]);

  // 🔒 1 linha por lead (dedupe por id)
  const leadsUnicas = useMemo(() => {
    const map = new Map();
    for (const l of leads || []) if (!map.has(l.id)) map.set(l.id, l);
    return [...map.values()];
  }, [leads]);

  const leadsComUltimo = useMemo(() => {
    return leadsUnicas.map((l) => ({
      ...l,
      _ultimo_agendamento: ultimoAgendamentoPorLead?.get
        ? ultimoAgendamentoPorLead.get(l.id)
        : ultimoAgendamentoPorLead?.[l.id] || null,
    }));
  }, [leadsUnicas, ultimoAgendamentoPorLead]);

  // Mapa: último agendamento dentro do período (qualquer status)

  const ultimoAgendamentoNoPeriodoPorLead = useMemo(() => {
    const tipo = (tipoDataFiltro || "").toLowerCase().trim();
    const filtroAtivo =
      tipo === "data_agendamento" &&
      (!!filtroDataAgendamento || !!dataInicio || !!dataFim);

    if (!filtroAtivo) return null;

    const alvoDia = filtroDataAgendamento
      ? soData(filtroDataAgendamento)
      : null;
    const ini = dataInicio ? soData(dataInicio) : null;
    const fim = dataFim ? soData(dataFim) : null;

    const map = new Map(); // lead_id -> agendamento mais recente no período

    for (const a of agendamentos || []) {
      if (!a || !a.lead_id) continue;

      // aceita todos os status (só ignora vazio)
      const temStatus =
        typeof a.status_agendamento === "string" &&
        a.status_agendamento.trim().length > 0;
      if (!temStatus) continue;

      const n = soData(a.data_agendamento);
      if (!n) continue;

      const dentro =
        alvoDia !== null
          ? n === alvoDia
          : (ini === null || n >= ini) && (fim === null || n <= fim);
      if (!dentro) continue;

      const atual = map.get(a.lead_id);
      const nAtual = atual ? soData(atual.data_agendamento) : null;

      // pega o mais recente por data; em empate, maior ID
      if (
        !atual ||
        n > nAtual ||
        (n === nAtual && Number(a.id) > Number(atual.id))
      ) {
        map.set(a.lead_id, a);
      }
    }

    return map;
  }, [
    agendamentos,
    tipoDataFiltro,
    filtroDataAgendamento,
    dataInicio,
    dataFim,
  ]);

  // Converte "YYYY-MM-DD" | "YYYY-MM-DD HH:mm:ss" | Date -> YYYYMMDD (número)
  function soData(x) {
    if (!x) return null;

    // Date nativo
    if (x instanceof Date && !isNaN(x)) {
      const y = x.getFullYear();
      const m = String(x.getMonth() + 1).padStart(2, "0");
      const d = String(x.getDate()).padStart(2, "0");
      return Number(`${y}${m}${d}`);
    }

    // String (suporta "YYYY-MM-DD" e "YYYY-MM-DD HH:mm:ss")
    if (typeof x === "string" && x.length >= 10) {
      const ymd = x.slice(0, 10).trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return Number(ymd.replace(/-/g, ""));
    }

    return null;
  }

  function removerAcentos(str) {
    return (str || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  // Cache por referência do array (rápido e compatível)
  const __nomeCache = new WeakMap();
  const __pickNome = (item) =>
    item?.nome ||
    item?.nome_fantasia ||
    item?.profissional ||
    item?.regiao ||
    item?.id ||
    "";

  const getNomeById = (id, lista) => {
    if (!Array.isArray(lista)) return id ?? "";
    let map = __nomeCache.get(lista);
    if (!map) {
      map = new Map();
      for (const it of lista) {
        map.set(String(it.id), __pickNome(it));
      }
      __nomeCache.set(lista, map);
    }
    return map.get(String(id)) ?? id ?? "";
  };

  // [FAST-NOME] — sanitizador simples (sem custo por tecla)
  function sanitizeNomeLead(txt = "") {
    return String(txt).replace(/\s+/g, " ").trim();
  }

  // [ITEM1] ===== Helpers de Nome =====
  const titleCase = (txt = "") =>
    txt
      .toLowerCase()
      .replace(/\s+/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase())
      .trim();

  // Turbo===== caches O(1) por id =====
  // ===== caches O(1) por id =====
  const tarefasPorLead = useMemo(() => {
    const map = new Map();
    for (const t of tarefas || []) {
      const k = String(t.lead_id);
      (map.get(k) || map.set(k, []).get(k)).push(t);
    }
    return map;
  }, [tarefas]);

  const interacoesPorLead = useMemo(() => {
    const map = new Map();
    for (const i of interacoes || []) {
      const k = String(i.id_lead ?? i.lead_id);
      (map.get(k) || map.set(k, []).get(k)).push(i);
    }
    return map;
  }, [interacoes]);

  const columns = useMemo(
    () => [
      {
        id: "bolinha_status",
        Header: () => (
          <div
            className="sticky left-0 z-20 bg-transparent flex justify-center items-center h-10 text-xl text-gray-700"
            title="Status da lead com base nas tarefas e interações"
          >
            🟢
          </div>
        ),
        Cell: ({ row }) => {
          try {
            const lead = row.original;

            // O(1): busca direta nos mapas
            const tarefasDaLead = tarefasPorLead.get(String(lead.id)) || [];
            const interacoesDaLead =
              interacoesPorLead.get(String(lead.id)) || [];

            if (tarefasDaLead.length === 0) {
              return (
                <div
                  className="sticky left-0 z-10 bg-white flex justify-center pt-[6px] text-xl"
                  title="Lead sem tarefa"
                >
                  <span style={{ color: "#FFA500" }}>⚠️</span>
                </div>
              );
            }

            const status = getCorBolinhaStatusLead(
              lead,
              tarefasDaLead,
              interacoesDaLead,
            );

            return (
              <div
                className="sticky left-0 z-10 bg-white flex justify-center pt-[6px] text-xl"
                title="Status calculado automaticamente"
              >
                {status?.emoji || "⚪"}
              </div>
            );
          } catch (err) {
            console.error("❌ Erro ao calcular bolinha da lead:", err);
            return (
              <div className="sticky left-0 z-10 bg-white flex justify-center pt-[6px] text-xl">
                ⚪
              </div>
            );
          }
        },
        disableFilters: true,
        disableSortBy: true,
      },

      {
        Header: () => (
          <div className="sticky left-10 z-10 bg-transparent text-white font-semibold px-2 py-1">
            Paciente
          </div>
        ),
        accessor: "nome_lead",
        Cell: ({ value }) => (
          <span className="text-sm font-medium text-blue-800 truncate max-w-[160px] block whitespace-nowrap">
            {value}
          </span>
        ),
      },

      {
        Header: () => <FaWhatsapp size={22} color="#25d366" title="WhatsApp" />,
        id: "whatsapp",
        Cell: ({ row }) => {
          const lead = row.original;
          const badgeData = badgesWhatsapp?.[lead?.id] || {};
          const badgeCount = badgeData.count || 0;
          const badgeStatus = badgeData.status || null;

          return (
            <button
              onClick={() => handleAbrirChatWhatsapp(lead)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                position: "relative",
                padding: 0,
              }}
              title="Abrir chat do WhatsApp"
            >
              <WhatsappIconWithBadge
                showBadge={!!badgeCount}
                badgeCount={badgeCount}
                badgeColor={badgeStatus}
              />
            </button>
          );
        },
        disableSortBy: true,
        disableFilters: true,
      },

      {
        Header: "Telefone",
        accessor: "telefone1",
        Cell: ({ value }) => (
          <span className="text-sm truncate max-w-[120px] block whitespace-nowrap">
            {value}
          </span>
        ),
      },
      {
        Header: "Procedimento",
        accessor: "id_procedimento",
        Cell: ({ value }) => (
          <span className="text-sm truncate max-w-[140px] block whitespace-nowrap">
            {getNomeById(value, procedimentos)}
          </span>
        ),
      },
      {
        Header: "Potencial",
        accessor: "potencial",
        Cell: ({ value }) => {
          const cores = {
            Alto: "bg-green-500",
            Médio: "bg-yellow-400",
            Baixo: "bg-pink-400",
          };
          return (
            <span
              className={`text-sm px-2 py-1 rounded-md font-medium text-white shadow-sm truncate max-w-[110px] block whitespace-nowrap ${
                cores[value] || "bg-gray-400"
              }`}
            >
              {value || "—"}
            </span>
          );
        },
      },
      {
        Header: "Total",
        accessor: "total_orcamento",
        Cell: ({ value }) => (
          <span className="text-blue-600 font-semibold text-sm">
            {Number(value || 0).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}
          </span>
        ),
      },
      {
        Header: "Fechado",
        accessor: "total_contratado",
        Cell: ({ row }) => (
          <div className="flex items-center justify-between gap-1">
            <span className="text-green-600 font-semibold text-sm">
              {(row.original.total_contratado || 0).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </span>
            <button
              onClick={() => {
                setLeadSelecionada(row.original);
                setModalRecebimentoAberto(true);
              }}
              className="p-1 hover:bg-green-100 rounded"
              title="Registrar recebimento"
            >
              <HandCoins className="text-green-600 w-5 h-5" />
            </button>
          </div>
        ),
      },
      {
        Header: "Status",
        id: "status_agendamento_periodo",
        Cell: ({ row }) => {
          const periodoAtivo =
            (tipoDataFiltro || "").toLowerCase().trim() ===
              "data_agendamento" &&
            (!!filtroDataAgendamento || !!dataInicio || !!dataFim);

          const ag = periodoAtivo
            ? (ultimoAgendamentoNoPeriodoPorLead?.get?.(row.original.id) ??
              null)
            : (row.original._ultimo_agendamento ??
              ultimoAgendamentoPorLead?.get?.(row.original.id) ??
              null);

          const valor = ag?.status_agendamento || "";
          const cores = {
            Agendado: "bg-blue-500",
            Reagendado: "bg-indigo-500",
            Compareceu: "bg-green-500",
            Faltou: "bg-red-500",
            Pendente: "bg-yellow-500",
            "Sem Contato": "bg-orange-500",
          };
          const alias = { Comparecimento: "Compareceu", Pendência: "Pendente" };
          const label = alias[valor] || valor || "—";
          const style = cores[label] || "bg-zinc-400";

          return (
            <span
              className={`px-3 py-1 rounded-md text-sm font-medium text-white shadow-sm ${style}`}
            >
              {label}
            </span>
          );
        },
      },

      {
        Header: "Agendado",
        id: "data_agendamento_periodo",
        Cell: ({ row }) => {
          const periodoAtivo =
            (tipoDataFiltro || "").toLowerCase().trim() ===
              "data_agendamento" &&
            (!!filtroDataAgendamento || !!dataInicio || !!dataFim);

          const ag = periodoAtivo
            ? (ultimoAgendamentoNoPeriodoPorLead?.get?.(row.original.id) ??
              null)
            : (row.original._ultimo_agendamento ??
              ultimoAgendamentoPorLead?.get?.(row.original.id) ??
              null);

          const value = ag?.data_agendamento;

          return (
            <div className="flex items-center gap-2 max-w-[120px]">
              {value ? (
                <span className="text-sm text-green-600 font-semibold truncate block whitespace-nowrap">
                  {value.slice(0, 10).split("-").reverse().join("/")}
                </span>
              ) : (
                <span className="text-sm text-slate-400 italic block whitespace-nowrap">
                  —
                </span>
              )}
              <button
                className="ml-1 text-blue-500 hover:text-blue-700"
                title="Agendar ou editar agendamento"
                onClick={() => {
                  setModalAgendamentoAberto(true);
                  setAgendamentoSelecionado(row.original);
                }}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                }}
                type="button"
              >
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
              </button>
            </div>
          );
        },
      },

      {
        Header: "Negociação",
        accessor: "status_negociacao",
        Cell: ({ value, row }) => {
          const lead = row.original;
          const label = (value ?? "—").toString().trim() || "—";
          const cores = {
            Fechado: "bg-green-500",
            "Fechado Parcial": "bg-emerald-400",
            Perdido: "bg-red-500",
            Negociando: "bg-yellow-400",
            Pendente: "bg-slate-400",
            "Migrou Concorrência": "bg-orange-500",
          };
          const cor = cores[label] || "bg-zinc-400";
          const empresaId = lead.empresa_id ?? usuarioLogado?.empresa_id;

          return (
            <div className="flex items-center gap-2">
              <CadeadoLead
                leadId={lead.id}
                cadeado={lead.cadeado}
                usuarioAtual={usuarioLogado}
                empresaId={empresaId}
                onStatusChange={(novo) =>
                  setLeads((arr) =>
                    arr.map((l) =>
                      l.id === lead.id ? { ...l, cadeado: novo } : l,
                    ),
                  )
                }
              />
              <span
                className={`px-3 py-1 rounded-md text-sm font-medium text-white shadow-sm ${cor}`}
              >
                {label}
              </span>
            </div>
          );
        },
      },

      {
        id: "tarefas",
        Header: () => (
          <div className="flex justify-center pt-[10px]">
            <CalendarCheck
              className="w-5 h-5 text-emerald-600"
              title="Tarefas da Lead"
            />
          </div>
        ),
        Cell: ({ row }) => (
          <div className="flex justify-center">
            <CalendarCheck
              onClick={() => abrirModalTarefa(row.original)}
              className="w-5 h-5 text-emerald-600 hover:text-emerald-800 transition cursor-pointer"
              title="Gerenciar tarefas"
            />
          </div>
        ),
        disableFilters: true,
      },
      {
        id: "interacoes",
        Header: () => (
          <div className="flex justify-center pt-[10px]">
            <PhoneCall
              className="w-5 h-5 text-yellow-500"
              title="Interações da Lead"
            />
          </div>
        ),
        Cell: ({ row }) => (
          <div className="flex justify-center">
            <PhoneCall
              onClick={() => abrirModalInteracoes(row.original)}
              className="w-5 h-5 text-yellow-500 hover:text-yellow-700 transition cursor-pointer"
              title="Ver interações"
            />
          </div>
        ),
        disableFilters: true,
      },
      {
        id: "acoes",
        Header: () => (
          <div
            className="sticky right-0 z-20 flex justify-center items-center h-10"
            title="Ações da lead"
          >
            <Target className="w-5 h-5 text-white" />
          </div>
        ),
        Cell: ({ row }) => (
          <DropdownAcoes
            lead={row.original}
            onEditar={() => handleEditar(row.original)} // wrapper evita TDZ
            onExcluir={() => handleExcluir(row.original.id)} // wrapper evita TDZ
            onVisualizarLogs={(lead) => {
              setLeadSelecionadaLogs(lead);
              setMostrarLogsModal(true);
            }}
          >
            <Target className="w-5 h-5 text-blue-600" />
          </DropdownAcoes>
        ),
        disableFilters: true,
        disableSortBy: true,
      },

      {
        Header: "Captador",
        accessor: "usuario_criador_id",
        Cell: ({ value }) => getPrimeiroNomeById(value, usuarios),
      },

      {
        Header: "Data",
        accessor: "data_lead",
        Cell: ({ value }) => {
          if (!value) return "";
          const [year, month, day] = value.split("-");
          const date = new Date(Number(year), Number(month) - 1, Number(day));
          return date.toLocaleDateString();
        },
      },
      {
        Header: "Região",
        accessor: "id_regiao",
        Cell: ({ value }) => getNomeById(value, regioes),
      },

      {
        Header: "Dentista",
        accessor: "id_dentista",
        Cell: ({ value }) => getNomeById(value, dentistas),
      },
      {
        Header: "Fonte",
        accessor: "id_fonte_lead",
        Cell: ({ value }) => (
          <span className="text-sm truncate max-w-[140px] block whitespace-nowrap">
            {getNomeById(value, fontes)}
          </span>
        ),
      },
      {
        Header: "Campanha",
        accessor: "nome_campanha",
        Cell: ({ value }) => (
          <span className="text-sm text-gray-800 truncate block max-w-[160px] whitespace-nowrap">
            {value || "—"}
          </span>
        ),
      },
      // ...colunas anteriores
      {
        Header: "Lançamento",
        accessor: "criado_em",
        Cell: ({ value }) =>
          value ? new Date(value).toLocaleDateString("pt-BR") : "—",
      },
    ],
    [
      tarefas,
      interacoes, // se usar nas células/bolinha
      procedimentos,
      regioes,
      usuarios,
      dentistas,
      fontes,
      badgesWhatsapp,

      // p/ Status/Agendado refletirem filtros de período
      tipoDataFiltro,
      dataInicio,
      dataFim,
      filtroDataAgendamento,
      ultimoAgendamentoNoPeriodoPorLead,
    ],
  );

  // Normaliza o tipo para evitar erro de comparação
  const tipo = (tipoDataFiltro || "").toLowerCase().trim();

  const leadsFiltradas = useMemo(() => {
    const M2 = appMarkStart("filter:leads", {
      tipo: tipoDataFiltro || null,
      nome: !!nomeFiltro,
      tel: !!telFiltro,
    });

    // 1) DEDUP
    const dedupLeads = (() => {
      const seen = new Set();
      const out = [];
      for (const l of leads || []) {
        if (!seen.has(l.id)) {
          seen.add(l.id);
          out.push(l);
        }
      }
      return out;
    })();

    const norm = (s) =>
      (s || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();

    const tipoNorm = norm(tipoDataFiltro);
    const periodoAtivo =
      tipoNorm === "data_agendamento" &&
      (!!filtroDataAgendamento || !!dataInicio || !!dataFim);

    const result = dedupLeads.filter((lead) => {
      const agendamentoRef = periodoAtivo
        ? (ultimoAgendamentoNoPeriodoPorLead?.get?.(lead.id) ?? null)
        : (lead._ultimo_agendamento ??
          (ultimoAgendamentoPorLead?.get
            ? ultimoAgendamentoPorLead.get(lead.id)
            : (ultimoAgendamentoPorLead?.[lead.id] ?? null)));

      if (periodoAtivo && !agendamentoRef) return false;

      if (filtroStatus) {
        const alvo = norm(filtroStatus);
        const s = norm(agendamentoRef?.status_agendamento);
        if (alvo === "agendado" || alvo === "reagendado") {
          if (!(s === "agendado" || s === "reagendado")) return false;
        } else {
          if (!agendamentoRef || s !== alvo) return false;
        }
      }

      if ((dataInicio || dataFim) && tipoNorm === "data_recebimento") {
        const recs = (recebLeads || []).filter(
          (r) => String(r.lead_id) === String(lead.id),
        );
        if (recs.length === 0) return false;
        const ini = dataInicio ? soData(dataInicio) : null;
        const fim = dataFim ? soData(dataFim) : null;
        const ok = recs.some((r) => {
          const nr = soData(r.data_recebimento);
          if (!nr) return false;
          if (ini !== null && nr < ini) return false;
          if (fim !== null && nr > fim) return false;
          return true;
        });
        if (!ok) return false;
      }

      if ((dataInicio || dataFim) && tipoNorm === "data_lead") {
        const dl = soData(lead.data_lead);
        if (dataInicio && (!dl || dl < soData(dataInicio))) return false;
        if (dataFim && (!dl || dl > soData(dataFim))) return false;
      }

      if ((dataInicio || dataFim) && tipoNorm === "criado_em") {
        const dc = soData(lead.criado_em);
        if (dataInicio && (!dc || dc < soData(dataInicio))) return false;
        if (dataFim && (!dc || dc > soData(dataFim))) return false;
      }

      if (filtroPotencial && lead.potencial !== filtroPotencial) return false;
      if (
        filtroStatusNegociacao &&
        lead.status_negociacao !== filtroStatusNegociacao
      )
        return false;
      if (filtroDentista && String(lead.id_dentista) !== String(filtroDentista))
        return false;
      if (filtroFonte && String(lead.id_fonte_lead) !== String(filtroFonte))
        return false;
      if (
        filtroCaptador &&
        String(lead.usuario_criador_id) !== String(filtroCaptador)
      )
        return false;
      if (filtroRegiao && String(lead.id_regiao) !== String(filtroRegiao))
        return false;
      if (filtroCampanha && String(lead.id_campanha) !== String(filtroCampanha))
        return false;
      if (
        filtroProcedimento &&
        String(lead.id_procedimento) !== String(filtroProcedimento)
      )
        return false;

      if (nomeFiltro && !norm(lead.nome_lead || "").includes(norm(nomeFiltro)))
        return false;

      if (
        telFiltro &&
        !(lead.telefone1 || "")
          .replace(/\D/g, "")
          .includes(telFiltro.replace(/\D/g, ""))
      ) {
        return false;
      }

      if (typeof mostrarInativas !== "undefined") {
        const neg = norm(lead.status_negociacao);
        const inativas = new Set(["perdido", "migrou concorrencia"]);
        if (mostrarInativas && !inativas.has(neg)) return false;
        if (!mostrarInativas && inativas.has(neg)) return false;
      }

      if (filtroPendenciasHoje) {
        const hojeStr = new Date().toISOString().slice(0, 10);
        const ts = (tarefas || []).filter(
          (t) => String(t.lead_id) === String(lead.id),
        );
        const ok = ts.some(
          (t) =>
            t.data_vencimento?.slice(0, 10) === hojeStr &&
            norm(t.status) !== "concluido",
        );
        if (!ok) return false;
      }

      if (filtroTarefasAtrasadas) {
        if (norm(lead.status_negociacao) === "fechado") return false;
        const hojeStr = new Date().toISOString().slice(0, 10);
        const ts = (tarefas || []).filter(
          (t) => String(t.lead_id) === String(lead.id),
        );
        const atrasada = ts.some(
          (t) =>
            t.data_vencimento?.slice(0, 10) < hojeStr &&
            norm(t.status) !== "concluido",
        );
        if (!atrasada) return false;
      }

      if (filtroSemTarefa) {
        const sneg = (lead.status_negociacao || "").toLowerCase().trim();
        if (sneg === "fechado") return false;
        const temTarefa = (tarefas || []).some(
          (t) => String(t.lead_id) === String(lead.id),
        );
        if (temTarefa) return false;
      }

      return true;
    });

    appMarkEnd(M2);
    return result;
  }, [
    leads,
    tarefas,
    recebLeads,
    ultimoAgendamentoPorLead,
    ultimoAgendamentoNoPeriodoPorLead,
    tipoDataFiltro,
    dataInicio,
    dataFim,
    filtroDataAgendamento,
    filtroStatus,
    filtroPotencial,
    filtroStatusNegociacao,
    filtroDentista,
    filtroFonte,
    filtroCaptador,
    filtroRegiao,
    filtroCampanha,
    filtroProcedimento,
    nomeFiltro,
    telFiltro,
    mostrarInativas,
    filtroPendenciasHoje,
    filtroTarefasAtrasadas,
    filtroSemTarefa,
  ]);

  const statusPrioridade = [
    "Negociando",
    "Prospectando",
    "Pendente",
    // outros status "abertos" que quiser
    "Fechado Parcial",
    "Fechado",
    "Perdido",
    "Migrou Concorrência",
  ];

  const leadsOrdenadas = useMemo(() => {
    const M3 = appMarkStart("sort:leads", { n: leadsFiltradas.length });

    const prioridadeCor = { vermelho: 1, azul: 2, amarelo: 3 };
    const statusPrioridade = [
      "Fechado",
      "Fechado Parcial",
      "Negociando",
      "Pendente",
      "Prospectando",
      "Migrou Concorrência",
      "Perdido",
    ];

    const arr = [...leadsFiltradas].sort((a, b) => {
      const aBadge = badgesWhatsapp[a.id] || {};
      const bBadge = badgesWhatsapp[b.id] || {};
      const pa = prioridadeCor[aBadge.status] || 999;
      const pb = prioridadeCor[bBadge.status] || 999;

      if (pa !== pb) return pa - pb;

      const ca = aBadge.count || 0;
      const cb = bBadge.count || 0;
      if (ca !== cb) return cb - ca;

      const ia = statusPrioridade.indexOf((a.status_negociacao || "").trim());
      const ib = statusPrioridade.indexOf((b.status_negociacao || "").trim());
      return ia - ib;
    });

    appMarkEnd(M3);
    return arr;
  }, [leadsFiltradas, badgesWhatsapp]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setGlobalFilter,
    state,
  } = useTable(
    {
      columns,
      data: leadsOrdenadas,
      defaultColumn,
      globalFilter: globalFilterFn,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
  );

  // ---- medir "pintura" do tbody (APÓS o useTable) ----
  useEffect(() => {
    if (!tbodyRef.current) return;
    const m = appMarkStart("paint:tbody", { rows: rows.length });

    const raf = requestAnimationFrame(() => {
      try {
        // força layout para garantir que o paint aconteceu antes de fechar a medição
        void tbodyRef.current.getBoundingClientRect();
      } finally {
        appMarkEnd(m);
      }
    });

    return () => cancelAnimationFrame(raf);
  }, [rows.length]);

  const handleLimparFiltros = () => {
    setGlobalFilter("");
    setFiltroPotencial("");
    setFiltroStatus("");
    setFiltroPeriodo("");
    setFiltroDentista("");
    setFiltroFonte("");
    setFiltroCaptador("");
    setFiltroRegiao("");
    setDataInicio("");
    setDataFim("");
    setFiltroCampanha("");
    setFiltroStatusNegociacao("");
    setFiltroProcedimento("");
    setFiltroDataAgendamento("");
    setNomeFiltro("");
  };

  const handleAbrirLegenda = () => setMostrarLegenda(true);
  const handleFecharLegenda = () => setMostrarLegenda(false);

  //Carregamento de tarefas

  const carregarTarefas = async () => {
    try {
      const empresaId = empresaAtiva?.id;
      const token = localStorage.getItem("token");
      if (!empresaId) {
        console.warn("⚠️ empresa_id não encontrado ou inválido");
        return;
      }
      const resp = await fetch(
        `${
          import.meta.env.VITE_API_BASE_URL
        }/todas-tarefas?empresa_id=${empresaId}`,
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            "Content-Type": "application/json",
          },
        },
      );
      if (!resp.ok) {
        const txt = await resp.text();
        console.error(`❌ Erro HTTP ao buscar tarefas (${resp.status}):`, txt);
        setTarefas([]);
        return;
      }
      const tarefas = await resp.json();
      setTarefas(Array.isArray(tarefas) ? tarefas : []);
    } catch (error) {
      console.error("❌ Erro ao carregar tarefas:", error);
      setTarefas([]);
    }
  };

  const carregarInteracoes = async () => {
    try {
      const empresaId = empresaAtiva?.id;
      const token = localStorage.getItem("token");
      if (!empresaId) {
        console.warn("⚠️ empresa_id não encontrado ou inválido");
        return;
      }
      const resp = await fetch(
        `${
          import.meta.env.VITE_API_BASE_URL
        }/todas-interacoes?empresa_id=${empresaId}`,
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            "Content-Type": "application/json",
          },
        },
      );
      if (!resp.ok) {
        const txt = await resp.text();
        console.error(
          `❌ Erro HTTP ao buscar interações (${resp.status}):`,
          txt,
        );
        setInteracoes([]);
        return;
      }
      const interacoes = await resp.json();
      setInteracoes(Array.isArray(interacoes) ? interacoes : []);
    } catch (error) {
      console.error("❌ Erro ao carregar interações:", error);
      setInteracoes([]);
    }
  };

  useEffect(() => {
    if (empresaAtiva?.id) {
      carregarTarefas();
      carregarInteracoes();
      fetchTodasLeads();
    }
  }, [empresaAtiva?.id]);

  // Utilitário para buscar quantidade de mensagens não lidas no WhatsApp
  async function buscarNaoLidas(lead_id, empresa_id) {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.warn("Token JWT ausente. Não autenticado!");
        return { count: 0, status: null };
      }
      const resp = await fetch(
        `/api/whatsapp/badge-status/lead/${lead_id}?empresa_id=${empresa_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (resp.status === 401 || resp.status === 403) {
        console.warn("Não autorizado ao buscar badge-status:", resp.status);
        return { count: 0, status: null };
      }
      const data = await resp.json();
      return {
        count: data.count || 0,
        status: data.status || null,
      };
    } catch (e) {
      console.warn("Erro ao buscar badge-status:", e);
      return { count: 0, status: null };
    }
  }

  useEffect(() => {
    let isMounted = true;

    async function atualizarBadges() {
      if (!Array.isArray(leadsFiltradas)) return;

      const novo = {};
      await Promise.all(
        leadsFiltradas
          .filter((lead) => !!lead?.id && !!lead?.empresa_id)
          .map(async (lead) => {
            try {
              const { count, status } = await buscarNaoLidas(
                lead.id,
                lead.empresa_id,
              );
              novo[lead.id] = { count, status };
            } catch (error) {
              console.warn("🥭 Erro ao buscar badge:", error);
              novo[lead.id] = { count: 0, status: null };
            }
          }),
      );

      if (isMounted) setBadgesWhatsapp(novo);
    }

    if (leadsFiltradas?.length) {
      atualizarBadges();
      const interval = setInterval(atualizarBadges, 30000);
      return () => {
        isMounted = false;
        clearInterval(interval);
      };
    }

    return () => {
      isMounted = false;
    };
  }, [leadsFiltradas]);

  //// Termometro /////////////////////////////////////

  useEffect(() => {
    if (!empresaAtiva?.id) return;
    const token = localStorage.getItem("token");
    let isMounted = true;

    fetch(
      `https://api.captacrm.com.br/receb_leads/financeiro/${empresaAtiva.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
      .then((res) => {
        if (!res.ok) {
          return res.text().then((text) => {
            throw new Error("Erro ao buscar recebimentos");
          });
        }
        return res.json();
      })
      .then((data) => {
        if (isMounted) setRecebLeads(data);
      })
      .catch(() => {
        if (isMounted) setRecebLeads([]);
      });

    return () => {
      isMounted = false;
    };
  }, [empresaAtiva?.id]);

  useEffect(() => {}, [interacoes]);

  // Sempre que fechar modal, recarregue ambos
  const fecharModalTarefa = () => {
    setModalAberto(false);
    fetchLeads();
    carregarTarefas();
    carregarInteracoes(); // ADICIONE AQUI!
  };

  // Fim carregamento tarefas

  const [modoVisualizacao, setModoVisualizacao] = useState(false);

  const [form, setForm] = useState({
    data_lead: "",
    nome_lead: "",
    telefone1: "",
    total_orcamento: "",
    total_contratado: "",
    data_agendamento: "",
    id_procedimento: "",
    id_regiao: "",
    id_usuario: usuarioLogado?.id || "", // SEMPRE operador logado!
    usuario_criador_id: "", // captador selecionado pelo usuário
    id_dentista: "",
    id_fonte_lead: "",
    empresa_id: usuarioLogado?.empresa_id || "",
    status_agendamento: "",
    potencial: "",
    status_negociacao: "",
    id_campanha: "",
  });

  const [tarefasDaLead, setTarefasDaLead] = useState([]);

  const abrirModalTarefa = async (lead) => {
    try {
      setLeadSelecionada(lead);
      setModalAberto(true);

      // Busca empresa_id corretamente
      const usuarioLogado = JSON.parse(localStorage.getItem("usuarioLogado"));
      const empresaAtiva = JSON.parse(localStorage.getItem("empresaAtiva"));
      const empresa_id = empresaAtiva?.id || usuarioLogado?.empresa_id;

      // Se não houver empresa, não busca
      if (!empresa_id) {
        toast.error("Empresa não definida para buscar tarefas!");
        setTarefasDaLead([]);
        return;
      }

      // 📍 Corrigido: envia empresa_id junto!
      const res = await api.get("/tarefas", {
        params: {
          lead_id: lead.id,
          empresa_id: empresa_id,
        },
      });

      const tarefas = Array.isArray(res?.data) ? res.data : [];
      setTarefasDaLead(tarefas);
      console.log(
        `📌 Tarefas da lead ${lead.id} (empresa ${empresa_id}):`,
        tarefas,
      );
    } catch (error) {
      console.error("❌ Erro ao carregar tarefas da lead:", error);
      toast.error("Erro ao carregar tarefas da lead");
      setTarefasDaLead([]);
    }
  };

  const abrirModalInteracoes = (lead) => {
    if (!lead || !lead.id) {
      toast.error("Lead inválida!");
      return;
    }
    setLeadSelecionadaParaInteracao(lead);
    setInteracoesModalAberto(true);
  };

  const abrirModalAgendamento = (lead) => {
    setAgendamentoSelecionado(lead);
    setModalAgendamentoAberto(true);
  };

  // ✅ Usa SEMPRE a empresa ativa
  const fetchTodasLeads = async () => {
    try {
      const empresaId =
        empresaAtiva?.id ||
        JSON.parse(localStorage.getItem("empresaAtiva") || "{}")?.id;

      if (!empresaId) {
        console.warn("❌ Nenhuma empresa ativa selecionada");
        setTodasLeads([]);
        return;
      }

      const url = `/leads?empresa_id=${empresaId}&mostrarInativas=true`;

      const res = await api.get(url);

      let leadsArr = [];
      if (Array.isArray(res)) {
        leadsArr = res;
      } else if (Array.isArray(res.data)) {
        leadsArr = res.data;
      } else if (res.data?.leads && Array.isArray(res.data.leads)) {
        leadsArr = res.data.leads;
      } else {
        console.warn("⚠️ Estrutura inesperada em todasLeads:", res);
        setTodasLeads([]);
        return;
      }

      setTodasLeads(leadsArr);
    } catch (error) {
      console.error("❌ Falha no fetchTodasLeads:", error);
      setTodasLeads([]);
    }
  };

  // Função final fetchLeads

  // Dentro do componente:

  const fetchLeads = async () => {
    // 🔹 inicia marcador (entra com os filtros atuais pra contexto)
    const __mFetch = appMarkStart("fetchLeads", {
      tipoDataFiltro,
      mostrarInativas,
      dataInicio,
      dataFim,
      filtroDataAgendamento: filtroDataAgendamento?.slice?.(0, 10) || null,
    });

    try {
      const empresaId = empresaAtiva?.id;
      if (!empresaId) {
        toast.error("Nenhuma empresa ativa selecionada.");
        setLeads([]);
        return;
      }

      const tipo = (tipoDataFiltro || "").toLowerCase().trim();

      // ✅ 1) DATA_AGENDAMENTO: usar endpoint dedicado
      if (tipo === "data_agendamento") {
        setLeads([]); // limpa antes de carregar

        // aceita: dia único (filtroDataAgendamento) OU período (dataInicio/dataFim)
        const start =
          (filtroDataAgendamento && filtroDataAgendamento.slice(0, 10)) ||
          (dataInicio && dataInicio.slice(0, 10)) ||
          null;
        const end =
          (filtroDataAgendamento && filtroDataAgendamento.slice(0, 10)) ||
          (dataFim && dataFim.slice(0, 10)) ||
          null;

        if (start && end) {
          try {
            const lista = await buscarLeadsPorAgendamento(
              empresaId,
              start,
              end,
            );
            setLeads(Array.isArray(lista) ? lista : []);
          } catch (e) {
            toast.error("Erro ao buscar leads por agendamento");
            setLeads([]);
          }
          return;
        }

        // Sem data -> traz tudo sem corte por data (cliente filtra depois, se quiser)
        let urlAll = `/leads?empresa_id=${empresaId}&mostrarInativas=${
          mostrarInativas ? "true" : "false"
        }`;
        const resAll = await api.get(urlAll);
        const arrAll = Array.isArray(resAll?.data)
          ? resAll.data
          : Array.isArray(resAll)
            ? resAll
            : resAll?.data?.leads || [];
        setLeads(arrAll);
        return;
      }

      // ✅ 2) DEMAIS TIPOS: montar URL sem forçar criado_em quando não for criado_em
      let url = `/leads?empresa_id=${empresaId}&mostrarInativas=${
        mostrarInativas ? "true" : "false"
      }`;

      if (tipo === "criado_em") {
        if (dataInicio)
          url += `&criado_em_inicio=${encodeURIComponent(dataInicio)}`;
        if (dataFim) url += `&criado_em_fim=${encodeURIComponent(dataFim)}`;
      }
      // Se o seu back aceitar, pode habilitar estes dois:
      // else if (tipo === "data_lead") {
      //   if (dataInicio) url += `&data_lead_inicio=${encodeURIComponent(dataInicio)}`;
      //   if (dataFim) url += `&data_lead_fim=${encodeURIComponent(dataFim)}`;
      // }
      // else if (tipo === "data_recebimento") {
      //   // normalmente filtramos client-side com recebLeads, então não mandamos nada aqui
      // }

      const res = await api.get(url);

      let leadsArr = [];
      if (Array.isArray(res)) {
        leadsArr = res;
      } else if (Array.isArray(res?.data)) {
        leadsArr = res.data;
      } else if (res?.data?.leads && Array.isArray(res.data.leads)) {
        leadsArr = res.data.leads;
      } else {
        console.warn("⚠️ Estrutura inesperada no retorno de leads:", res);
        leadsArr = [];
      }

      setLeads(leadsArr);
    } catch (error) {
      toast.error("Erro ao carregar leads");
      setLeads([]);
    } finally {
      // 🔹 finaliza marcador sempre (sucesso ou erro)
      if (__mFetch) appMarkEnd(__mFetch);
    }
  };

  //Atualiza a tabela como status e data agendamento

  const atualizarLeadNaTabela = (leadId, ultimoAgendamento) => {
    setLeads((leadsAntigos) =>
      leadsAntigos.map((lead) =>
        lead.id === leadId
          ? {
              ...lead,
              status_agendamento: ultimoAgendamento?.status_agendamento || "",
              data_agendamento: ultimoAgendamento?.data_agendamento || "",
              _ultimo_agendamento: ultimoAgendamento || null, // 👈 chave nova
            }
          : lead,
      ),
    );
  };

  ///////////////////Interacoes////////////////////////////////////////////////

  useEffect(() => {
    if (leadSelecionadaParaInteracao) {
      setInteracoesDaLead(
        interacoes.filter((i) => i.lead_id === leadSelecionadaParaInteracao.id),
      );
    } else {
      setInteracoesDaLead([]);
    }
  }, [interacoes, leadSelecionadaParaInteracao]);

  // Salvar interação

  const salvarInteracao = async (novaInteracao) => {
    try {
      const usuarioLogado = JSON.parse(localStorage.getItem("usuarioLogado"));
      if (!leadSelecionadaParaInteracao) {
        toast.error("Nenhuma lead selecionada.");
        return;
      }
      const payload = {
        ...novaInteracao,
        empresa_id: usuarioLogado.empresa_id,
        id_lead: leadSelecionadaParaInteracao.id,
      };
      await api.post("/interacoes", payload);
      toast.success("✅ Interação salva com sucesso!");
      await carregarInteracoes();
      // Não precisa novo GET, só filtrar do global caso queira exibir no modal:
      setInteracoesDaLead(
        interacoes.filter((i) => i.lead_id === leadSelecionadaParaInteracao.id),
      );
    } catch (error) {
      console.error("❌ Erro ao salvar interação:", error);
      toast.error("Erro ao salvar interação");
    }
  };

  // Excluir interação
  const excluirInteracao = async (id) => {
    try {
      if (!window.confirm("Tem certeza que deseja excluir esta interação?"))
        return;
      await api.delete(`/interacoes/${id}`);
      toast.success("🗑️ Interação excluída com sucesso!");
      await carregarInteracoes();
      setInteracoesDaLead(
        interacoes.filter((i) => i.lead_id === leadSelecionadaParaInteracao.id),
      );
    } catch (error) {
      console.error("❌ Erro ao excluir interação:", error);
      toast.error("Erro ao excluir interação");
    }
  };

  // Fim salvar excluir Interacaoes

  // Função para validar telefone: DDD + 9 + número = 11 dígitos
  function telefoneValido(telefone) {
    if (!telefone) return false;
    const apenasNumeros = telefone.replace(/\D/g, "");
    return apenasNumeros.length === 11;
  }

  const abrirModalRecebimento = (lead) => {
    setLeadSelecionada(lead);
    setModalRecebimentoAberto(true);
  };
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [editandoId, setEditandoId] = useState(null);

  const handleInserirLead = () => {
    const usuarioLogado = JSON.parse(localStorage.getItem("usuarioLogado"));
    setMostrarFormulario(true);
    setEditandoId(null);
    setForm({
      data_lead: "",
      nome_lead: "",
      telefone1: "",
      total_orcamento: "",
      total_contratado: "",
      data_agendamento: "",
      id_procedimento: "",
      id_regiao: "",
      id_usuario: usuarioLogado?.id || "", // operador logado!
      usuario_criador_id: "", // captador selecionado
      id_dentista: "",
      id_fonte_lead: "",
      empresa_id: usuarioLogado?.empresa_id || "",
      status_agendamento: "",
      potencial: "",
      status_negociacao: "",
      id_campanha: "",
    });
  };

  const [erros, setErros] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "data_lead") {
      const hoje = new Date().toISOString().split("T")[0];
      if (value > hoje) {
        setErros((prev) => ({
          ...prev,
          data_lead: "A data não pode ser no futuro.",
        }));
        return;
      } else {
        setErros((prev) => ({ ...prev, data_lead: null }));
      }
    }
    if (name === "telefone1") {
      const onlyNumbers = value.replace(/\D/g, "").slice(0, 11);
      const formatted = onlyNumbers
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2");
      setForm({ ...form, [name]: formatted });

      // Validação ao digitar telefone1
      if (onlyNumbers.length !== 11) {
        setErros((prev) => ({
          ...prev,
          telefone1: "Telefone deve ter 11 dígitos (DDD + 9 + número)",
        }));
      } else {
        setErros((prev) => ({ ...prev, telefone1: null }));
      }
      return;
    } else if (name === "total_orcamento" || name === "total_contratado") {
      const cleaned = value.replace(/\D/g, "");
      const numeric = (parseInt(cleaned || 0, 10) / 100).toFixed(2);
      const formatted = "R$ " + numeric.replace(".", ",");
      setForm({ ...form, [name]: formatted });
    } else if (name === "nome_lead") {
      const formatado = value
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase());
      setForm({ ...form, [name]: formatado });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Flags e utilidades
    const usuarioLogado = JSON.parse(
      localStorage.getItem("usuarioLogado") || "{}",
    );
    const empresaAtivaLS = JSON.parse(
      localStorage.getItem("empresaAtiva") || "{}",
    );
    const isEdit = Boolean(editandoId);
    const endpoint = isEdit ? `/leads/${editandoId}` : "/leads";

    // Empresa final (form > contexto > LS > usuário)
    const empresaIdFinal = Number(
      form.empresa_id ||
        empresaAtiva?.id ||
        empresaAtivaLS?.id ||
        usuarioLogado?.empresa_id,
    );
    if (!empresaIdFinal) {
      toast.error("Selecione a empresa antes de salvar a lead.");
      return;
    }

    // Helpers locais
    const isEmpty = (v) =>
      v == null || (typeof v === "string" && v.trim() === "");
    const clean = (obj) =>
      Object.fromEntries(Object.entries(obj).filter(([_, v]) => !isEmpty(v)));
    const toNum = (v) => (isEmpty(v) ? null : Number(v));
    const toMoney = (v) => {
      if (v == null || v === "") return null;
      if (typeof v === "number") return isFinite(v) ? v : null;
      const s = String(v)
        .replace(/\s|R\$\s?/g, "")
        .trim();
      if (/^[\d.]+,\d{2}$/.test(s))
        return Number(s.replace(/\./g, "").replace(",", "."));
      const n = Number(s.replace(/[^\d.\-]/g, ""));
      return isNaN(n) ? null : n;
    };
    const normDate = (d) => {
      if (!d) return null;
      let dt = null;
      if (d instanceof Date && !isNaN(d)) dt = d;
      else {
        const s = String(d).trim();
        const br = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (br) dt = new Date(+br[3], +br[2] - 1, +br[1], 0, 0, 0, 0);
        if (!dt) {
          const ymdH = s.match(
            /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/,
          );
          if (ymdH)
            dt = new Date(
              +ymdH[1],
              +ymdH[2] - 1,
              +ymdH[3],
              +ymdH[4],
              +ymdH[5],
              +(ymdH[6] || 0),
              0,
            );
        }
        if (!dt) {
          const ymd = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
          if (ymd) dt = new Date(+ymd[1], +ymd[2] - 1, +ymd[3], 0, 0, 0, 0);
        }
        if (!dt) {
          const iso = s.includes("T") ? s : s.replace(" ", "T");
          const tmp = new Date(iso);
          if (!isNaN(tmp)) dt = tmp;
        }
      }
      if (!dt) return null;
      const pad = (n) => String(n).padStart(2, "0");
      return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(
        dt.getDate(),
      )} ${pad(dt.getHours())}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}`;
    };

    // 🔹 Validações SOMENTE para criação
    if (!isEdit) {
      const hoje = new Date().toISOString().split("T")[0];

      // telefone: 11 dígitos (DDD+9+número)
      if (!telefoneValido(form.telefone1)) {
        toast.error(
          "⛔ O telefone deve conter exatamente 11 dígitos (DDD + 9 + número).",
        );
        return;
      }

      // data da lead
      if (!form.data_lead) {
        toast.error("⛔ Informe a data da lead.");
        return;
      }
      if (form.data_lead > hoje) {
        toast.error("⛔ A data da lead não pode ser no futuro.");
        return;
      }

      // status agendamento x data_agendamento
      const status = form.status_agendamento?.trim();
      const statusExigemData = ["Agendado", "Reagendado", "Compareceu"];
      if (statusExigemData.includes(status) && !form.data_agendamento) {
        toast.error(
          "⛔ Informe a data do agendamento para o status selecionado.",
        );
        return;
      }

      // status de negociação
      if (
        !form.status_negociacao ||
        typeof form.status_negociacao !== "string" ||
        !form.status_negociacao.trim()
      ) {
        toast.error("⛔ Informe corretamente o status de negociação da lead.");
        return;
      }

      // campanha obrigatória
      if (
        form.id_campanha === undefined ||
        form.id_campanha === "" ||
        form.id_campanha === null
      ) {
        toast.error("⛔ Selecione uma campanha para a lead.");
        return;
      }

      // duplicidade básica
      const leadDuplicada = leads.find(
        (l) =>
          l.nome_lead?.toLowerCase().trim() ===
            form.nome_lead?.toLowerCase().trim() &&
          l.telefone1?.replace(/\D/g, "") ===
            form.telefone1?.replace(/\D/g, ""),
      );
      if (leadDuplicada) {
        toast.warning("⚠️ Já existe uma lead com o mesmo nome e telefone!");
        return;
      }
    }

    try {
      let payload;

      if (!isEdit) {
        // === POST: criação ===
        const status = form.status_agendamento?.trim();
        const statusExigemData = ["Agendado", "Reagendado", "Compareceu"];
        const deveSerInativa =
          status === "Perdido" || status === "Migrou para Concorrência";

        payload = clean({
          empresa_id: empresaIdFinal,
          id_usuario: toNum(usuarioLogado?.id), // operador logado
          usuario_criador_id: toNum(form.usuario_criador_id), // captador
          nome_lead: form.nome_lead,
          data_lead: normDate(form.data_lead),
          id_procedimento: toNum(form.id_procedimento),

          // opcionais
          telefone1: form.telefone1,
          total_orcamento: toMoney(form.total_orcamento),
          total_contratado: toMoney(form.total_contratado),
          data_agendamento: statusExigemData.includes(status)
            ? normDate(form.data_agendamento)
            : null,
          id_regiao: toNum(form.id_regiao),
          id_dentista: toNum(form.id_dentista),
          id_fonte_lead: toNum(form.id_fonte_lead),
          id_campanha: toNum(form.id_campanha),
          status_agendamento: form.status_agendamento,
          potencial: form.potencial,
          status_negociacao: form.status_negociacao,
          inativo: deveSerInativa ? 1 : 0,
        });

        if (
          !payload.empresa_id ||
          !payload.usuario_criador_id ||
          !payload.nome_lead ||
          !payload.data_lead ||
          !payload.id_procedimento
        ) {
          throw new Error(
            "Preencha empresa, captador, nome, data e procedimento.",
          );
        }

        console.log("📦 payload /leads (POST):", payload);
        const response = await api.post(endpoint, payload);
        console.log("✅ Resposta da API (create):", response?.data || response);
        toast.success("Lead salva com sucesso!");
      } else {
        // === PUT: edição — envie payload COMPLETO ===
        const novoCaptador = Number(form.usuario_criador_id);
        if (!Number.isInteger(novoCaptador) || novoCaptador <= 0) {
          toast.error("Selecione um captador válido.");
          return;
        }

        const status = form.status_agendamento?.trim();
        const statusExigemData = ["Agendado", "Reagendado", "Compareceu"];

        payload = clean({
          empresa_id: empresaIdFinal,
          id_usuario: toNum(usuarioLogado?.id), // operador logado (quem está editando)
          usuario_criador_id: toNum(form.usuario_criador_id), // captador
          nome_lead: form.nome_lead,
          data_lead: normDate(form.data_lead),
          id_procedimento: toNum(form.id_procedimento),

          // opcionais (mas enviados para satisfazer o schema do back)
          telefone1: form.telefone1,
          total_orcamento: toMoney(form.total_orcamento),
          total_contratado: toMoney(form.total_contratado),
          data_agendamento: statusExigemData.includes(status)
            ? normDate(form.data_agendamento)
            : null,
          id_regiao: toNum(form.id_regiao),
          id_dentista: toNum(form.id_dentista),
          id_fonte_lead: toNum(form.id_fonte_lead),
          id_campanha: toNum(form.id_campanha),
          status_agendamento: form.status_agendamento,
          potencial: form.potencial,
          status_negociacao: form.status_negociacao,
        });

        // Validação mínima para evitar 400 por campos faltando
        if (
          !payload.empresa_id ||
          !payload.usuario_criador_id ||
          !payload.nome_lead ||
          !payload.data_lead ||
          !payload.id_procedimento
        ) {
          toast.error(
            "Campos obrigatórios ausentes: empresa, captador, nome, data e procedimento.",
          );
          return;
        }

        console.log("📦 payload /leads (PUT):", payload);
        const response = await api.put(endpoint, payload);
        console.log("✅ Resposta da API (edit):", response?.data || response);
        toast.success("Lead atualizada com sucesso!");
      }

      // Pós-sucesso
      fetchLeads();
      setMostrarFormulario(false);
      setEditandoId(null);
      setForm({
        data_lead: "",
        nome_lead: "",
        telefone1: "",
        total_orcamento: "",
        total_contratado: "",
        data_agendamento: "",
        id_procedimento: "",
        id_regiao: "",
        id_usuario: "",
        usuario_criador_id: "",
        id_dentista: "",
        id_fonte_lead: "",
        empresa_id: "",
        id_campanha: "",
        status_agendamento: "",
        status_negociacao: "",
      });
    } catch (err) {
      console.error(
        "❌ Erro ao salvar lead:",
        err?.response?.status,
        err?.response?.data || err,
      );
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err.message ||
        "Erro ao salvar lead. Verifique os campos obrigatórios.";
      toast.error(msg);
    }
  };

  const fetchDataForSelects = async () => {
    try {
      const fontesRes = await api.get("/fonteslead"); // exige token
      const procedimentosRes = await api.get("/procedimentos"); // ok sem token, mas mantém padrão

      const fontesArr = Array.isArray(fontesRes)
        ? fontesRes
        : Array.isArray(fontesRes?.data)
          ? fontesRes.data
          : [];

      const procedimentosArr = Array.isArray(procedimentosRes)
        ? procedimentosRes
        : Array.isArray(procedimentosRes?.data)
          ? procedimentosRes.data
          : [];

      setFontes(fontesArr);
      setProcedimentos(procedimentosArr);

      if (!fontesArr.length) console.warn("⚠️ /fonteslead retornou vazio.");
      if (!procedimentosArr.length)
        console.warn("⚠️ /procedimentos retornou vazio.");
    } catch (err) {
      console.error("Erro ao carregar fontes/procedimentos:", err);
      toast.error("Erro ao carregar fontes/procedimentos");
    }
  };

  const fetchRegioes = async () => {
    const res = await api.get("/regioes");
    setRegioes(res);
  };

  const fetchUsuarios = async () => {
    try {
      const token = localStorage.getItem("token"); // onde você guardou no login
      const empresaId = empresaAtiva?.id;

      const response = await fetch(
        `https://api.captacrm.com.br/usuarios?empresa_id=${empresaId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await response.json();

      if (!Array.isArray(data)) {
        console.warn("⚠️ [fetchUsuarios] estrutura inesperada:", data);
        setUsuarios([]);
        return;
      }

      setUsuarios(data);
    } catch (error) {
      console.error("❌ Erro ao buscar usuários:", error);
      setUsuarios([]);
    }
  };

  const fetchDentistas = async () => {
    try {
      const id = empresaAtiva?.id;
      if (!id) {
        setDentistas([]);
        return;
      }

      const token = localStorage.getItem("token");
      const r = await fetch(`https://api.captacrm.com.br/dentistas/${id}`, {
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      setDentistas(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("❌ fetchDentistas:", e);
      setDentistas([]);
    }
  };

  const fetchEmpresas = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch("https://api.captacrm.com.br/empresas", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      if (!res.ok) {
        const txt = await res.text();
        throw new Error(`Erro ${res.status}: ${txt}`);
      }
      const data = await res.json();
      if (Array.isArray(data)) {
        setEmpresas(data);
      } else {
        setEmpresas([]);
      }
    } catch (error) {
      setEmpresas([]);
      console.error("Erro ao buscar empresas:", error);
    }
  };

  useEffect(() => {
    fetchEmpresas();
  }, []);

  // Busca todas as campanhas (como fazia antes)

  const fetchCampanhas = async () => {
    try {
      const usuarioLogado = JSON.parse(
        localStorage.getItem("usuarioLogado") || "{}",
      );
      const empresaAtiva = JSON.parse(
        localStorage.getItem("empresaAtiva") || "{}",
      );

      const empresaId =
        empresaAtiva?.id ??
        empresaAtiva?.empresa_id ??
        usuarioLogado?.empresa_id;

      if (!empresaId) {
        console.warn(
          "❌ Nenhuma empresa_id encontrada (empresaAtiva/usuarioLogado).",
        );
        setCampanhas([]);
        return;
      }

      // Base da API e token (com Bearer se faltar)
      const API = (
        import.meta?.env?.VITE_API_BASE_URL || "https://api.captacrm.com.br"
      ).replace(/\/$/, "");
      const raw =
        localStorage.getItem("token") ||
        localStorage.getItem("authToken") ||
        localStorage.getItem("jwt") ||
        "";
      const token = raw
        ? raw.startsWith("Bearer ")
          ? raw
          : `Bearer ${raw}`
        : "";

      const url = `${API}/campanhas?empresa_id=${empresaId}`;
      console.log("🌐 GET:", url);

      const res = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: token } : {}),
        },
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data?.erro || data?.error || res.statusText);

      const lista = Array.isArray(data)
        ? data
        : Array.isArray(data?.campanhas)
          ? data.campanhas
          : [];

      setCampanhas(lista);
    } catch (error) {
      console.error("❌ Falha no fetchCampanhas:", error);
      setCampanhas([]);
    }
  };

  useEffect(() => {
    fetchLeads();
    fetchDataForSelects();
    fetchRegioes();
    fetchUsuarios();
    fetchDentistas();
    fetchEmpresas();
    fetchCampanhas();
  }, []);

  useEffect(() => {
    fetchLeads();
    fetchTodasLeads();
  }, [mostrarInativas]);
  const handleEditar = (lead) => {
    setForm({
      data_lead: lead.data_lead
        ? new Date(lead.data_lead).toISOString().split("T")[0]
        : "",
      nome_lead: lead.nome_lead || "",
      telefone1: lead.telefone1 || "",
      total_orcamento: lead.total_orcamento
        ? `R$ ${parseFloat(lead.total_orcamento).toFixed(2).replace(".", ",")}`
        : "",
      total_contratado: lead.total_contratado
        ? `R$ ${parseFloat(lead.total_contratado).toFixed(2).replace(".", ",")}`
        : "",
      data_agendamento: lead.data_agendamento?.slice(0, 10) || "",
      id_procedimento: lead.id_procedimento || "",
      id_regiao: lead.id_regiao || "",
      id_usuario: lead.id_usuario || "",
      id_dentista: lead.id_dentista || "",
      id_fonte_lead: lead.id_fonte_lead || "",
      empresa_id: lead.empresa_id || "",
      status_agendamento: lead.status_agendamento || "",
      potencial: lead.potencial || "",
      id_campanha: lead.id_campanha || "",
      usuario_criador_id: lead.usuario_criador_id || "",
      status_negociacao: lead.status_negociacao || "",
    });
    setEditandoId(lead.id);
    setMostrarFormulario(true);
  };

  // Função específica para usuários
  function getNomeUsuarioById(id, usuarios) {
    const usuario = usuarios.find((u) => String(u.id_usuario) === String(id));
    return usuario ? usuario.nome : "";
  }

  const handleExcluir = async (id) => {
    if (!window.confirm("Tem certeza que deseja excluir esta lead?")) return;
    try {
      await api.delete(`/leads/${id}`); // se não lançar, deu bom
      toast.success("Lead excluída com sucesso!");
      await fetchLeads();
    } catch (err) {
      console.error("Erro ao excluir lead:", err);
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "Erro ao excluir lead.";
      toast.error(msg);
    }
  };

  const getStatusCorDaUltimaTarefa = (leadId, statusLead) => {
    if (!Array.isArray(tarefas)) return "bg-slate-300";
    const tarefasDaLead = tarefas
      .filter((t) => String(t.lead_id) === String(leadId))
      .sort(
        (a, b) => new Date(b.data_vencimento) - new Date(a.data_vencimento),
      );
    const ultima = tarefasDaLead[0];
    if (!ultima) return "bg-slate-300";
    const todasConcluidas = tarefasDaLead.every(
      (t) => t.status?.toLowerCase() === "concluído",
    );
    const hojeStr = new Date().toISOString().split("T")[0];
    const vencimentoStr = new Date(ultima.data_vencimento)
      .toISOString()
      .split("T")[0];
    const status = ultima.status?.toLowerCase();
    if (todasConcluidas && statusLead?.toLowerCase() === "fechado") {
      return "bg-green-500";
    }
    if (["pendente", "em andamento"].includes(status)) {
      if (vencimentoStr === hojeStr) return "bg-blue-400";
      if (vencimentoStr < hojeStr) return "bg-red-500";
      if (vencimentoStr > hojeStr) return "bg-blue-400";
    }
    return "bg-slate-300";
  };

  function globalFilterFn(rows, columnIds, filterValue) {
    if (!filterValue) return rows;
    const termo = removerAcentos(filterValue.toLowerCase().trim());
    const termoNumerico = termo.replace(/\D/g, "");
    console.log("🔍 Termo digitado:", termo);
    return rows.filter((row) => {
      const nome = removerAcentos(row.original.nome_lead?.toLowerCase() || "");
      const telefone = row.original.telefone1?.replace(/\D/g, "") || "";
      const matchNome = nome.includes(termo);
      const matchTel = telefone.includes(termoNumerico);
      return matchNome || matchTel;
    });
  }

  return (
    <>
      <div className="min-h-screen pt-0 px-1 pb-1">
        <NotificacaoTarefa tarefas={tarefas} leads={leads} />
        <div className="max-w-[98%] mx-auto">
          <IndicadoresLeads
            leads={todasLeads}
            tarefas={tarefas}
            empresaId={empresaAtiva?.id}
          />
        </div>
        <ToastContainer position="bottom-right" autoClose={3001} />
        <div className="max-w-[98%] mx-auto bg-white px-2 py-2 rounded-xl shadow border border-slate-300">
          <div className="flex items-center justify-between mb-6">
            <div>
              <div className="flex items-center gap-3">
                <img
                  src={logoCapta}
                  alt="Logo CaptaCRM"
                  className="w-32 h-32 object-contain drop-shadow-md"
                />
                <div className="-ml-2">
                  <h1 className="text-3xl font-bold text-blue-800 leading-tight">
                    Gestão de Leads
                  </h1>
                  <p className="text-base text-blue-700 font-medium -mt-1">
                    Captação com inteligência.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-end gap-2">
              <button
                onClick={() => {
                  if (mostrarFormulario) {
                    setMostrarFormulario(false);
                    setEditandoId(null);
                    setForm({
                      data_lead: "",
                      nome_lead: "",
                      telefone1: "",
                      total_orcamento: "",
                      total_contratado: "",
                      data_agendamento: "",
                      id_procedimento: "",
                      id_regiao: "",
                      id_usuario: "",
                      id_dentista: "",
                      id_fonte_lead: "",
                      empresa_id: "",
                      status_agendamento: "",
                    });
                  } else {
                    handleInserirLead();
                  }
                }}
                className={`w-48 flex items-center justify-center gap-2 ${
                  mostrarFormulario
                    ? "bg-red-600 hover:bg-red-700"
                    : "bg-gradient-to-r from-blue-900 via-blue-800 to-blue-700 hover:brightness-110"
                } text-white font-semibold px-5 py-2 rounded-md shadow-md transition-all duration-300`}
              >
                {mostrarFormulario ? (
                  <>
                    <Trash className="w-5 h-5" /> Cancelar
                  </>
                ) : (
                  <>
                    <PlusCircle className="w-5 h-5" /> Inserir Lead
                  </>
                )}
              </button>
              <button
                onClick={() => setMostrarInativas(!mostrarInativas)}
                className={`w-48 flex items-center justify-center gap-2 bg-white border-2 ${
                  mostrarInativas
                    ? "border-green-500 text-green-700"
                    : "border-gray-400 text-gray-600 hover:border-blue-500 hover:text-blue-800"
                } font-semibold px-5 py-2 rounded-md shadow-md transition-all duration-300`}
              >
                {mostrarInativas
                  ? "✅ Inativos visíveis"
                  : "🧊 Checar inativos"}
              </button>
              {mostrarFormulario && (
                <button
                  onClick={handleSubmit}
                  className="w-48 flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold px-5 py-2 rounded-md shadow-md transition-all duration-300"
                >
                  <Save className="w-4 h-4" /> Salvar Lead
                </button>
              )}
            </div>
          </div>
          {mostrarFormulario && (
            <FormLead
              form={form}
              setForm={setForm}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              erros={erros}
              empresas={empresas}
              campanhas={campanhas}
              procedimentos={procedimentos}
              fontes={fontes}
              regioes={regioes}
              usuarios={usuarios}
              dentistas={dentistas}
              editandoId={editandoId}
            />
          )}
          {mostrarLogsModal && (
            <LogsModalLead
              lead={leadSelecionadaLogs}
              onClose={() => setMostrarLogsModal(false)}
              tarefas={tarefas}
              interacoesDaLead={interacoesDaLead}
              usuarios={usuarios}
            />
          )}
          <ModalLegendaBolinhas
            isOpen={mostrarLegenda}
            onClose={handleFecharLegenda}
          />
          <TarefaModal
            isOpen={modalAberto}
            onClose={fecharModalTarefa}
            lead={leadSelecionada}
            onSalvarTarefa={() => {
              fetchLeads();
              carregarTarefas();
            }}
          />

          <RecebimentoModal
            isOpen={modalRecebimentoAberto}
            onClose={() => setModalRecebimentoAberto(false)}
            lead={leadSelecionada}
            onRecebimentoSalvo={() => {
              fetchLeads();
              // ...atualizar recebimentos se necessário
            }}
          />
          <InteracoesModal
            isOpen={interacoesModalAberto}
            onClose={fecharModalInteracao}
            lead={leadSelecionadaParaInteracao}
            tarefas={tarefas}
            onChangeInteracoes={(novasInteracoesDaLead) =>
              setInteracoes((prev) => [
                ...prev.filter(
                  (i) =>
                    String(i.id_lead) !==
                    String(leadSelecionadaParaInteracao.id),
                ),
                ...novasInteracoesDaLead,
              ])
            }
          />
          <AgendamentosModal
            isOpen={modalAgendamentoAberto}
            onClose={() => setModalAgendamentoAberto(false)}
            lead={agendamentoSelecionado}
            onUltimoAgendamento={(ultimo) =>
              atualizarLeadNaTabela(agendamentoSelecionado.id, ultimo)
            }
            onAgendamentoSalvo={fetchLeads} // <-- Adicione isso!
          />

          <div className="w-full bg-gradient-to-r from-blue-300 via-purple-200 to-pink-200 border-2 border-blue-300 shadow-2xl rounded-2xl px-4 py-2 flex flex-col gap-2">
            <div className="flex gap-2 items-end flex-wrap">
              {/* Filtro dinâmico */}
              <FiltroDataDinamico
                tipoData={tipoDataFiltro}
                setTipoData={setTipoDataFiltro}
                dataInicio={dataInicio}
                setDataInicio={setDataInicio}
                dataFim={dataFim}
                setDataFim={setDataFim}
                erroData={erroData}
              />

              <div className="flex flex-row items-end gap-2 min-w-[48px]">
                <RankingCaptadores
                  usuarios={usuarios}
                  recebimentos={recebLeads}
                  leads={leads}
                  empresaId={empresaAtiva?.id}
                  filtroTipo="mensal" // ou "todos" para diagnóstico
                  anoSelecionado={2025}
                  mesSelecionado={8}
                  strictVendedor={false}
                  debug
                />
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {/* Campo Nome */}
              <div className="flex flex-col w-[168px]">
                <label className="text-[10px] font-bold text-blue-600 mb-0.5 ml-1 tracking-wider drop-shadow">
                  🔤 Nome
                </label>
                <div className="relative">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-blue-400 text-[11px] pointer-events-none">
                    🔍
                  </span>
                  <input
                    value={nomeFiltro}
                    onChange={(e) => {
                      setNomeFiltro(e.target.value);
                      // removido setFilter("nome_lead", ...)
                    }}
                    placeholder="Filtrar por Nome"
                    type="text"
                    className="pl-7 pr-2 h-8 rounded-xl border-2 border-blue-400 text-blue-700 font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-pink-200 transition-all duration-200 w-full text-[11px]"
                  />
                </div>
              </div>

              {/* Telefone */}
              <div className="flex flex-col w-[130px]">
                <label className="text-[10px] font-bold text-purple-600 mb-0.5 ml-1 tracking-wider drop-shadow">
                  📞 Telefone
                </label>
                <div className="relative">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-purple-400 text-[11px] pointer-events-none">
                    📱
                  </span>
                  <input
                    value={telFiltro}
                    onChange={(e) => {
                      setTelFiltro(e.target.value);
                      // removido setFilter("telefone1", ...)
                    }}
                    placeholder="Telefone"
                    type="text"
                    className="pl-7 pr-2 h-8 rounded-xl border-2 border-purple-400 text-purple-700 font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-200 w-full text-[11px]"
                  />
                </div>
              </div>

              {/* Potencial */}
              <div className="flex flex-col w-[130px]">
                <label className="text-[10px] font-bold text-pink-600 mb-0.5 ml-1 tracking-wider drop-shadow">
                  🎯 Potencial
                </label>
                <div className="relative">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-pink-400 text-[11px] pointer-events-none">
                    ⭐️
                  </span>
                  <select
                    value={filtroPotencial}
                    onChange={(e) => setFiltroPotencial(e.target.value)}
                    className="pl-7 pr-2 h-8 rounded-xl border-2 border-pink-400 text-pink-700 font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-purple-200 transition-all duration-200 w-full text-[11px]"
                  >
                    <option value="">Potencial</option>
                    <option value="Alto">⬆️ Alto</option>
                    <option value="Médio">↔️ Médio</option>
                    <option value="Baixo">⬇️ Baixo</option>
                  </select>
                </div>
              </div>

              {/* Status */}
              <div className="flex flex-col w-[130px]">
                <label className="text-[10px] font-bold text-blue-500 mb-0.5 ml-1 tracking-wider drop-shadow">
                  📌 Status
                </label>
                <div className="relative">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-blue-400 text-[11px] pointer-events-none">
                    📍
                  </span>
                  <select
                    value={filtroStatus}
                    onChange={(e) => setFiltroStatus(e.target.value)}
                    className="pl-7 pr-2 h-8 rounded-xl border-2 border-blue-400 text-blue-700 font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-pink-200 transition-all duration-200 w-full text-[11px]"
                  >
                    <option value="">Status</option>
                    <option value="Agendado">📅 Agendado</option>
                    <option value="Reagendado">🔁 Reagendado</option>
                    <option value="Compareceu">🟢 Compareceu</option>
                    <option value="Faltou">🔴 Faltou</option>
                    <option value="Pendente">🟡 Pendente</option>
                  </select>
                </div>
              </div>

              {/* Negociação */}
              <div className="flex flex-col w-[130px]">
                <label className="text-[10px] font-bold text-pink-600 mb-0.5 ml-1 tracking-wider drop-shadow">
                  💼 Negociação
                </label>
                <div className="relative">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-pink-400 text-[11px] pointer-events-none">
                    💼
                  </span>
                  <select
                    value={filtroStatusNegociacao}
                    onChange={(e) => setFiltroStatusNegociacao(e.target.value)}
                    className="pl-7 pr-2 h-8 rounded-xl border-2 border-pink-400 text-pink-700 font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-200 w-full text-[11px]"
                  >
                    <option value="">Negociação</option>
                    {statusNegociacaoOpcoes.map((opcao) => (
                      <option key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Dentista */}
              <div className="flex flex-col w-[130px]">
                <label className="text-[10px] font-bold text-purple-600 mb-0.5 ml-1 tracking-wider drop-shadow">
                  🧑‍⚕️ Dentista
                </label>
                <div className="relative">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-purple-400 text-[11px] pointer-events-none">
                    🧑‍⚕️
                  </span>
                  <select
                    value={filtroDentista}
                    onChange={(e) => setFiltroDentista(e.target.value)}
                    className="pl-7 pr-2 h-8 rounded-xl border-2 border-purple-400 text-purple-700 font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-200 w-full text-[11px]"
                  >
                    <option value="">Dentista</option>
                    {dentistas.map((d) => (
                      <option key={d.id} value={d.id}>
                        {d.profissional}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Fonte */}
              <div className="flex flex-col w-[130px]">
                <label className="text-[10px] font-bold text-blue-600 mb-0.5 ml-1 tracking-wider drop-shadow">
                  🌐 Fonte
                </label>
                <div className="relative">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-blue-400 text-[11px] pointer-events-none">
                    🌐
                  </span>
                  <select
                    value={filtroFonte}
                    onChange={(e) => setFiltroFonte(e.target.value)}
                    className="pl-7 pr-2 h-8 rounded-xl border-2 border-blue-400 text-blue-700 font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-pink-200 transition-all duration-200 w-full text-[11px]"
                  >
                    <option value="">Fonte</option>
                    {fontes.map((f) => (
                      <option key={f.id} value={f.id}>
                        {f.nome}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Captador */}
              <div className="flex flex-col w-[130px]">
                <label className="text-[10px] font-bold text-pink-600 mb-0.5 ml-1 tracking-wider drop-shadow">
                  🙋‍♂️ Captador
                </label>
                <div className="relative">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-pink-400 text-[11px] pointer-events-none">
                    🙋‍♂️
                  </span>

                  {console.log("🟢 [RENDER] usuarios:", usuarios)}

                  <select
                    value={filtroCaptador}
                    onChange={(e) => setFiltroCaptador(e.target.value)}
                    className="pl-7 pr-2 h-8 rounded-xl border-2 border-pink-400 text-pink-700 font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-200 w-full text-[11px]"
                  >
                    <option value="">Captador</option>

                    {usuarios.length > 0 ? (
                      usuarios.map((u) => (
                        <option key={u.id} value={u.id}>
                          {u.nome}
                        </option>
                      ))
                    ) : (
                      <option disabled>🔍 Nenhum captador encontrado</option>
                    )}
                  </select>
                </div>
              </div>

              {/* Região */}
              <div className="flex flex-col w-[130px]">
                <label className="text-[10px] font-bold text-purple-600 mb-0.5 ml-1 tracking-wider drop-shadow">
                  📍 Região
                </label>
                <div className="relative">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-purple-400 text-[11px] pointer-events-none">
                    📍
                  </span>
                  <select
                    value={filtroRegiao}
                    onChange={(e) => setFiltroRegiao(e.target.value)}
                    className="pl-7 pr-2 h-8 rounded-xl border-2 border-purple-400 text-purple-700 font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-200 w-full text-[11px]"
                  >
                    <option value="">Região</option>
                    {regioes.map((r) => (
                      <option key={r.id} value={r.id}>
                        {r.regiao}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Campanha */}
              <div className="flex flex-col w-[130px]">
                <label className="text-[10px] font-bold text-blue-600 mb-0.5 ml-1 tracking-wider drop-shadow">
                  📢 Campanha
                </label>
                <div className="relative">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-blue-400 text-[11px] pointer-events-none">
                    📢
                  </span>
                  <select
                    value={filtroCampanha}
                    onChange={(e) => setFiltroCampanha(e.target.value)}
                    className="pl-7 pr-2 h-8 rounded-xl border-2 border-blue-400 text-blue-700 font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-pink-200 transition-all duration-200 w-full text-[11px]"
                  >
                    <option value="">Campanha</option>
                    {campanhas.map((camp) => (
                      <option key={camp.id} value={camp.id}>
                        {camp.nome}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-2">
                {/* Procedimento sem label */}
                <div className="flex flex-col w-[168px]">
                  <div className="relative">
                    <span className="absolute left-2 top-1/2 -translate-y-1/2 text-pink-400 text-[11px] pointer-events-none">
                      🦷
                    </span>
                    <select
                      value={filtroProcedimento}
                      onChange={(e) => setFiltroProcedimento(e.target.value)}
                      className="pl-7 pr-2 h-8 rounded-xl border-2 border-pink-400 text-pink-700 font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-200 w-full text-[11px]"
                    >
                      <option value="">Procedimento</option>
                      {procedimentos.map((proc) => (
                        <option key={proc.id} value={proc.id}>
                          {proc.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Botão Limpar Filtros */}
                <button
                  onClick={handleLimparFiltros}
                  className="flex items-center justify-center gap-1 w-[130px] h-8 bg-red-100 hover:bg-red-200 text-red-700 border-2 border-red-400 rounded-xl text-[11px] shadow-md font-bold transition-all duração-200"
                  style={{ minWidth: 0, minHeight: 0, lineHeight: 1 }}
                >
                  <span style={{ fontSize: 12 }}>🧹</span>
                  Limpar
                </button>

                {/* Botão Imprimir */}
                <button
                  onClick={() => {
                    localStorage.setItem(
                      "leadsParaImpressao",
                      JSON.stringify(leadsFiltradas),
                    );
                    window.open("/imprimir-leads", "_blank");
                  }}
                  className="flex items-center justify-center gap-1 w-[130px] h-8 bg-gray-300 hover:bg-gray-400 text-gray-900 border-2 border-gray-500 rounded-xl text-[11px] shadow-md font-bold transition-all duração-200"
                  style={{ minWidth: 0, minHeight: 0, lineHeight: 1 }}
                >
                  <span
                    role="img"
                    aria-label="imprimir"
                    style={{ fontSize: 12 }}
                  >
                    🖨️
                  </span>
                  Imprimir
                </button>

                {/* Botão Legenda */}
                <button
                  onClick={() => setMostrarLegenda(!mostrarLegenda)}
                  title="Ver legenda dos status"
                  className="flex items-center justify-center w-[130px] h-8 bg-white border border-blue-200 rounded-xl shadow transition-all duração-150 hover:shadow-lg hover:border-blue-400"
                  style={{
                    minWidth: 0,
                    minHeight: 0,
                    lineHeight: 1,
                    padding: 0,
                  }}
                >
                  <span
                    className="inline-block rounded-full shadow"
                    style={{
                      width: 13,
                      height: 13,
                      background:
                        "linear-gradient(135deg, #60a5fa 60%, #2563eb 100%)",
                      border: "2px solid #2563eb",
                      boxShadow: "0 0 4px #2563eb44",
                    }}
                  ></span>
                  <span className="ml-2 text-[11px] text-blue-700 font-semibold">
                    Legenda
                  </span>
                </button>

                {/* Contador Leads */}
                <span className="flex items-center justify-center gap-1 w-[130px] h-8 bg-white border border-blue-200 text-blue-700 font-semibold rounded-xl shadow transition-all duração-150 hover:shadow-lg hover:border-blue-400 select-none text-[11px]">
                  <span
                    role="img"
                    aria-label="Contador"
                    className="mr-1 text-[11px]"
                  >
                    🔢
                  </span>
                  <CountUp
                    key={leadsFiltradas.length}
                    end={leadsFiltradas.length}
                    duration={1.2}
                  />
                </span>

                {/* Switches */}
                <label className="flex items-center gap-2 cursor-pointer select-none w-[130px] h-8 bg-white border border-green-200 rounded-xl shadow transition-all duração-150 hover:shadow-lg hover:border-green-400 justify-center">
                  <input
                    type="checkbox"
                    checked={soMeusLeads}
                    onChange={() => {
                      if (soMeusLeads) {
                        setFiltroCaptador("");
                        setSoMeusLeads(false);
                      } else {
                        handleLimparFiltros();
                        setFiltroCaptador(usuarioLogado?.id);
                        setSoMeusLeads(true);
                      }
                    }}
                    className="sr-only peer"
                  />
                  <div className="w-10 h-5 bg-gray-300 rounded-full peer-checked:bg-green-400 transition-colors relative">
                    <div className="absolute left-1 top-0.5 w-4 h-4 bg-white rounded-full shadow-md peer-checked:left-5 transition-all"></div>
                  </div>
                  <span className="text-[11px] text-green-700 font-semibold transition-colors">
                    Captador
                  </span>
                </label>

                <label className="flex items-center gap-2 cursor-pointer select-none w-[130px] h-8 bg-white border border-yellow-200 rounded-xl shadow transition-all duração-150 hover:shadow-lg hover:border-yellow-400 justify-center">
                  <input
                    type="checkbox"
                    checked={filtroPendenciasHoje}
                    onChange={() => setFiltroPendenciasHoje((v) => !v)}
                    className="sr-only peer"
                  />
                  <div className="w-10 h-5 bg-gray-300 rounded-full peer-checked:bg-yellow-400 transition-colors relative">
                    <div className="absolute left-1 top-0.5 w-4 h-4 bg-white rounded-full shadow-md peer-checked:left-5 transition-all"></div>
                  </div>
                  <span className="text-[11px] text-yellow-700 font-semibold transition-colors">
                    Day
                  </span>
                </label>

                <label className="flex items-center gap-2 cursor-pointer select-none w-[130px] h-8 bg-white border border-red-200 rounded-xl shadow transition-all duração-150 hover:shadow-lg hover:border-red-400 justify-center">
                  <input
                    type="checkbox"
                    checked={filtroTarefasAtrasadas}
                    onChange={() => setFiltroTarefasAtrasadas((v) => !v)}
                    className="sr-only peer"
                  />
                  <div className="w-10 h-5 bg-gray-300 rounded-full peer-checked:bg-red-400 transition-colors relative">
                    <div className="absolute left-1 top-0.5 w-4 h-4 bg-white rounded-full shadow-md peer-checked:left-5 transition-all"></div>
                  </div>
                  <span className="text-[11px] text-red-700 font-semibold transition-colors">
                    Atraso
                  </span>
                </label>

                <label className="flex items-center gap-2 cursor-pointer select-none w-[130px] h-8 bg-white border border-orange-200 rounded-xl shadow transition-all duração-150 hover:shadow-lg hover:border-orange-400 justify-center">
                  <input
                    type="checkbox"
                    checked={filtroSemTarefa}
                    onChange={() => setFiltroSemTarefa((v) => !v)}
                    className="sr-only peer"
                  />
                  <div className="w-10 h-5 bg-gray-300 rounded-full peer-checked:bg-orange-400 transition-colors relative">
                    <div className="absolute left-1 top-0.5 w-4 h-4 bg-white rounded-full shadow-md peer-checked:left-5 transition-all"></div>
                  </div>
                  <span className="text-[11px] text-orange-700 font-semibold transition-colors">
                    Sem Tarefa
                  </span>
                </label>
              </div>

              <LeadsExportExcel
                rows={rows}
                columns={columns}
                procedimentos={procedimentos}
                dentistas={dentistas}
                regioes={regioes}
                usuarios={usuarios}
                fontes={fontes}
                campanhas={campanhas}
              />
              <TermometroConversao
                leads={leads}
                recebLeads={recebLeads}
                empresaId={empresaAtiva?.id}
              />
            </div>
          </div>

          <div className="w-full max-h-[600px] mt-4 overflow-auto border rounded shadow-inner scrollbar-thin scrollbar-thumb-blue-600 scrollbar-track-blue-100">
            <table
              id="tabela-leads" // <- necessário pra telemetria
              {...getTableProps()}
              className="min-w-[1200px] table-auto border-collapse"
            >
              <thead className="sticky top-0 z-30 shadow-xl bg-gradient-to-r from-blue-900 via-blue-700 to-blue-500 rounded-t-xl overflow-hidden">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column, index) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps(),
                        )}
                        className={`
                text-center font-semibold px-4 py-3 text-sm uppercase tracking-wider text-white font-sans
                ${
                  index === 0
                    ? "sticky left-0 z-40 shadow-md border-r border-blue-400 backdrop-blur-sm"
                    : ""
                }
                ${
                  index === 1
                    ? "sticky left-[45px] z-30 shadow-sm border-r border-blue-400 backdrop-blur-sm"
                    : ""
                }
                ${index === 0 ? "rounded-tl-xl" : ""}
                ${
                  index === headerGroup.headers.length - 1
                    ? "rounded-tr-xl"
                    : ""
                }
              `}
                      >
                        <div className="flex justify-center items-center gap-1 select-none">
                          {column.render("Header")}
                          {column.isSorted && (
                            <span className="text-white text-xs">
                              {column.isSortedDesc ? "↓" : "↑"}
                            </span>
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>

              <tbody
                ref={tbodyRef}
                {...getTableBodyProps()}
                className="bg-white"
              >
                {rows.map((row) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      className="hover:bg-yellow-100 transition"
                    >
                      {row.cells.map((cell) => (
                        <td
                          {...cell.getCellProps()}
                          className={`
                          px-4 py-2 border-b border-slate-200 text-sm text-gray-800 whitespace-nowrap
                          ${
                            cell.column.id === "bolinha_status"
                              ? "sticky left-0 z-20 bg-white shadow-md"
                              : ""
                          }
                          ${
                            cell.column.id === "nome_lead"
                              ? "sticky left-10 z-10 bg-white shadow border-r border-slate-300"
                              : ""
                          }
                        `}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {leadChatAberto && empresaAtiva?.id && (
        <LeadsWhatsApp
          lead={leadChatAberto}
          empresaId={empresaAtiva.id} // ✅ Aqui o certo!
          onClose={() => setLeadChatAberto(null)}
          usuarios={usuarios}
          dentistas={dentistas}
          procedimentos={procedimentos}
          agendamentos={agendamentos}
        />
      )}
    </>
  );
}
